import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardContent, CardHeader, IconButton,
} from '@mui/material';
import { faFileExcel, faQuestion, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, AlertTitle } from '@mui/lab';

const iconMap = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': faFileExcel,
};

function ExchangeFile({
  filename, type, loading, err, success, onDeleteFile,
}) {
  const icon = useMemo(
    () => (type in iconMap ? iconMap[type] : faQuestion),
    [type],
  );
  return (
    <Card>
      <CardHeader
        titleTypographyProps={{ color: 'primary' }}
        avatar={<FontAwesomeIcon icon={icon} size="lg" bounce={loading} />}
        title={filename}
        action={(
          <IconButton color="warning" onClick={() => onDeleteFile(filename)}>
            <FontAwesomeIcon icon={faTimes} size="xs" />
          </IconButton>
        )}
      />

      <CardContent>
        {err && (
          <Alert severity="error">
            <AlertTitle>{err}</AlertTitle>
          </Alert>
        )}
        {success && (
          <Alert severity="success">
            <AlertTitle>Виконано вдало</AlertTitle>
          </Alert>
        )}
      </CardContent>
    </Card>
  );
}

ExchangeFile.propTypes = {
  filename: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  err: PropTypes.string,
  success: PropTypes.bool.isRequired,
  onDeleteFile: PropTypes.func.isRequired,
};

ExchangeFile.defaultProps = {
  err: null,
};

export default ExchangeFile;
